import * as React from "react";
import { NumericFormat } from "react-number-format";

export function DisplayNumber(props: { value: number; fixedDecimalScale?: boolean; decimalScale?: number }) {
	return <NumericFormat value={props.value} displayType={"text"} thousandSeparator={true} fixedDecimalScale={props.fixedDecimalScale} decimalScale={props.decimalScale} />;
}
